import { 
  GET_WEBHOOK_DATA_REQUEST, 
  GET_WEBHOOK_DATA_SUCCESS, 
  GET_WEBHOOK_DATA_FAILURE,
  FETCH_SUBSCRIPTION_HISTORY_REQUEST,
  FETCH_SUBSCRIPTION_HISTORY_SUCCESS,
  FETCH_SUBSCRIPTION_HISTORY_FAILURE
} from '../actions/billingActions';

const initialState = {
  webhookData: null,
  loading: false,
  error: null,
  subscriptionHistory: [],
  historyLoading: false,
  historyError: null
};

export default function billingReducer(state = initialState, action) {
  switch (action.type) {
    case GET_WEBHOOK_DATA_REQUEST:
      return { ...state, loading: true, error: null };
    
    case GET_WEBHOOK_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        webhookData: action.payload,
        error: null
      };
    
    case GET_WEBHOOK_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    
    case FETCH_SUBSCRIPTION_HISTORY_REQUEST:
      return { ...state, historyLoading: true, historyError: null };
    
    case FETCH_SUBSCRIPTION_HISTORY_SUCCESS:
      return {
        ...state,
        historyLoading: false,
        subscriptionHistory: action.payload,
        historyError: null
      };
    
    case FETCH_SUBSCRIPTION_HISTORY_FAILURE:
      return {
        ...state,
        historyLoading: false,
        historyError: action.error
      };
    
    default:
      return state;
  }
}
